import React from 'react';
import './DashboardButton.css';

export const DashboardButton = ({ title, text, onClick, disabled, required, width, hoverable }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const buttonClass = hoverable ? 'dashboard-button hoverable' : 'dashboard-button';

  return (
    <button style={{ width }} disabled={disabled} className={buttonClass} onClick={handleClick}>
      <div>
        <div className="button-title">{title}</div>
        {text && <div className="button-text">{text}</div>}
      </div>
    </button>
  );
};
